// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PI8wK","col":"styles_col__15B3t"};